import { render, staticRenderFns } from "./governmentEdit.vue?vue&type=template&id=2e848ae0&scoped=true&"
import script from "./governmentEdit.vue?vue&type=script&lang=js&"
export * from "./governmentEdit.vue?vue&type=script&lang=js&"
import style0 from "./governmentEdit.vue?vue&type=style&index=0&id=2e848ae0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e848ae0",
  null
  
)

export default component.exports